import CompositeFormField from './composite-field.js';

export default class EmploymentDetails extends CompositeFormField {
    constructor(parent, el) {
        super(parent, el);        
        this.disableHistoryTypes = ['4', '22', '23', '2', '7', '6', '24'] // Disable job details for: Retired (4), Full-Time Carer (22), Independent (23), Unemployed (2), Full Time Student (7), Home Maker (6), Non-Working (24)
        this.type = this.field('type');
        this.typeInput = this.type.inputs[0].el;
        this.duration = this.field('duration');
        this.years = this.duration.input('years');
        this.months = this.duration.input('months');
        this.bind();
    }

    bind() {
        this.typeInput.addEventListener('change', (e) => {
            if(!this.disabled()) {
                this.checkJobType();
            }
        })
    }

    isDisabledType() {
        const value = this.typeInput.value;
        return this.disableHistoryTypes.includes(value);
    }

    checkJobType() {         
        if (this.isDisabledType()) {
            this.fields.forEach((f) => {
                (f.el.dataset.id !== 'type') ? f.hide() : f.show();
                (f.el.dataset.id !== 'type') ? f.disable() : f.enable();
            });
        } else {
            this.fields.forEach((f) => {
                f.show();
                f.enable();
            });
        }

        this.update(this);
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_employment_details');
    }
}
